import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\ItemDossier\AddPackToDossierController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/AddPackToDossierController.php
* @route '/api/dossier/{dossier}/pack'
*/
const AddPackToDossierController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddPackToDossierController.url(args, options),
    method: 'post',
})

AddPackToDossierController.definition = {
    methods: ["post"],
    url: '/api/dossier/{dossier}/pack',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\ItemDossier\AddPackToDossierController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/AddPackToDossierController.php
* @route '/api/dossier/{dossier}/pack'
*/
AddPackToDossierController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return AddPackToDossierController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\ItemDossier\AddPackToDossierController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/AddPackToDossierController.php
* @route '/api/dossier/{dossier}/pack'
*/
AddPackToDossierController.post = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddPackToDossierController.url(args, options),
    method: 'post',
})

export default AddPackToDossierController